export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5326.88acbbcf.jpg";